// src/App.jsx
import { AuthProvider } from "./AuthContext";
import AppRoutes from "./AppRoutes"; // O tus rutas

export default function App() {
  return (
    <AuthProvider>
      <AppRoutes />
    </AuthProvider>
  );
}


